import React from "react";
import styles from '../../assets/styles/Onboarding/AccountInReview.module.scss';
import { MimaButton, MimaText } from "../../components";
import { businessStore, userStore } from "../../stores";
import LeftSide from '../pageComponents/LeftSide';
import ReviewImg from '../../assets/img/underReview.png';
import { useMediaQuery } from 'react-responsive';
import MimaLogo from '../../assets/img/mima-logo.png';
import { useNavigate } from 'react-router-dom';
import constant from '../../utils/constant';

const AccountInReview = ({
	validationSchema,
	onSubmit,
	loading
}) => {
  const airPage = true;
  const isBelow900 = useMediaQuery({
		query: '(max-width: 900px)',
	});

  const navigate = useNavigate();

	const goToLanding = () => {
		navigate(constant.Routes.Home);
	};

  return (
    <div className={styles.container}>			
        <img src={MimaLogo} className={styles.logo} onClick={goToLanding} />
				<img src={ReviewImg} alt="Account in review" className={styles.inReview}/>
        <MimaText variant="h3" color="var(--color-primary)" mt={1}>Thank you for signing up!</MimaText>
        <MimaText mt={1} width={40} align="center">Your account is undergoing review and we will respond shortly</MimaText>	
        {/* <MimaText mt={5} variant="smallBold" align="center">
          <span style={{color: "var(--color-primary)"}}>With mima you can;</span><br/>
          Send invoices/receipts, <br/>
          Manage your customers, <br/>
          Manage your employees, <br/>
          Track your income and expenses <br/>
          and so many other great features.  
        </MimaText>			 */}
        <MimaButton title="Go back Home" buttonColor="var(--color-dark)" onClick={goToLanding} mt={3}/>
		</div>
  );
};

export default AccountInReview;
